// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HCDGK","content":"styles_content__1hpel"};